import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsAlphanumeric, IsOptional, Matches, MaxLength } from "class-validator";


export class ContractorDto{

    @ApiProperty()
    @IsNotEmpty({message: 'Contractor Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    contractorId:number;

    @ApiProperty()
    @IsNotEmpty({message:'Contractor Name should not be empty'})
    contractorName:string;

    @ApiProperty()
    @IsNotEmpty({message:'Contractor Project Id should not be empty'})
    contractorProId:string;

    @ApiProperty()
    @IsNotEmpty({message:'Contractor Type should not be empty'})
    contractorType:string;

    @ApiProperty()
    @IsNotEmpty({message:'No Of Employees should not be empty'})
    noOfEmployees:number;

    @ApiProperty()
    @IsNotEmpty({message:'From Date should not be empty'})
    fromDate:Date;

    @ApiProperty()
    @IsNotEmpty({message:'To Date should not be empty'})
    toDate:Date;

    @ApiProperty()
    @IsNotEmpty({message:'Contract Period should not be empty'})
    contractPeriod:string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Created User allows maximum 40 characters'})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;


}